﻿import './sections.css'
const INDUSTRIES = [
  { icon: '💻', name: 'Software Engineering', desc: 'Adaptive coding interviews and technical assessments that evaluate how engineers think and solve problems.' },
  { icon: '📈', name: 'Sales and Revenue Roles', desc: 'Competency assessments that evaluate communication, objection handling, and revenue-driving capabilities.' },
  { icon: '📋', name: 'Project Management', desc: 'Scenario-based interviews that assess planning, stakeholder management, and delivery competencies.' },
  { icon: '🎧', name: 'Customer Support', desc: 'Conversational assessments that measure empathy, problem-solving, and service excellence at scale.' },
  { icon: '💰', name: 'Finance and Operations', desc: 'Role-specific evaluations for analytical thinking, compliance awareness, and operational competencies.' },
  { icon: '🌐', name: 'Any Industry', desc: 'The platform evaluates competencies rather than job titles — making it adaptable to any role in any sector.' },
]
export default function IndustriesSection() {
  return (
    <section id="industries" className="industries-section section">
      <div className="container">
        <p className="section-eyebrow">INDUSTRY SOLUTIONS</p>
        <h2 className="section-title">AI Interviews for Every Role, Across Every Industry</h2>
        <p className="section-subtitle">Workforce intelligence isn't industry-specific — PossoBuild adapts to your organisation's structure, roles, and ways of working.</p>
        <div className="industries-grid">
          {INDUSTRIES.map(i => (
            <div key={i.name} className="industry-card">
              <div className="industry-icon">{i.icon}</div>
              <h3>{i.name}</h3>
              <p>{i.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
